import { Injectable, signal } from '@angular/core';

/**
 * Persists the landing page's search across navigation (EB-3621). Returning to the landing —
 * e.g. via browser back after opening a result — restores the query, which re-runs the search.
 *
 * Landing-scoped by design: the global-search overlay does NOT write here (its searches are
 * transient), so only searches started on the landing are remembered.
 */
@Injectable({ providedIn: 'root' })
export class SearchStateService {
  /** The last query entered on the landing (empty = none). */
  readonly landingQuery = signal('');
}
